import { Text, Title } from '@components/v2/ui';
import {
	Box,
	NumberFormatter,
	Progress,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

type FundedPartProgressBarProps = {
	total: number;
	allocated: number;
};

export default function FundedPartProgressBar({
	total,
	allocated,
}: FundedPartProgressBarProps) {
	const { t } = useTranslation();

	const percentage = (allocated / total) * 100;

	return (
		<Box w={'70%'}>
			<Title c={'#505058'} order={6}>
				{t('global.fundsAllocatedToSupportTheProjects')} :{' '}
				<Text c={'#1D3965'} size="20px" span>
					<NumberFormatter
						thousandSeparator=" "
						decimalSeparator=","
						value={total}
						decimalScale={2}
						suffix="€"
					/>
				</Text>
			</Title>

			<Box mt={12} mb={8}>
				<Progress
					value={percentage}
					size="lg"
					radius="xl"
					styles={{
						root: {
							backgroundColor: '#A9B4C7',
						},
						section: {
							backgroundColor: '#0F2C59',
						},
					}}
				/>
			</Box>

			<Text c={'#97AAC1'} variant="subtitle1">
				{t('global.allocated')} :{' '}
				<Text span c={'#617EEF'} fw={600}>
					<NumberFormatter
						thousandSeparator=" "
						decimalSeparator=","
						value={allocated}
						decimalScale={2}
						suffix="€"
					/>
				</Text>{' '}
				/{' '}
				<NumberFormatter
					thousandSeparator=" "
					decimalSeparator=","
					value={total}
					decimalScale={2}
					suffix="€"
				/>
			</Text>
		</Box>
	);
}
